<template>
  <v-app>
    <!-- left naviragiont panel when on smartphone -->
    <v-navigation-drawer
        temporary
        v-model="drawer"
        fixed>
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="title">
              Menu
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list dense class="pt-0">
        <!-- <v-list-tile v-show="!item.hide_menu"
        v-for="item in menuItems"
        :key="item.title"
        :disabled="item.disable_menu"
        router
        :to="item.link">
          <v-list-tile-action>
            <v-icon v-if="item.link !== '/wiki'">{{item.icon}}</v-icon>
            <v-img width="22" max-width="22" v-if="item.link === '/wiki'" :src="trWikiImgDisabled" />
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{item.title}}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->

        <v-list-tile router to="/">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Home</v-list-tile-content>
        </v-list-tile>

        <v-list-tile router to="/about">
          <v-list-tile-action>
            <v-icon>help</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>About</v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <v-list-tile>
          <v-list-tile-content style="font-weight:bold;">TR Search engine</v-list-tile-content>
        </v-list-tile>
   
        <v-list-tile router to="/about">
          <v-list-tile-action>
            <v-icon>help</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>About</v-list-tile-content>
        </v-list-tile>

        <v-list-tile router to="/press">
          <v-list-tile-action>
            <v-icon>description</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Press</v-list-tile-content>
        </v-list-tile>

        <v-list-tile router to="/e-commerce-pulse">
          <v-list-tile-action>
            <v-icon>hdr_strong</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>E-Commerce Pulse</v-list-tile-content>
        </v-list-tile>

        <v-list-tile router to="/lighthouse">
          <v-list-tile-action>
            <v-icon>trending_up</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Lighthouse Index</v-list-tile-content>
        </v-list-tile>

        <v-list-tile router to="/admin"
          v-show="!this.disableMenuItems('admin')"
          :disabled="this.disableMenuItems('admin')">
          <v-list-tile-action>
            <v-icon>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Admin</v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="authenticated"
          flat
          @click="logout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Logout</v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="!authenticated"
          flat
          @click="login">
          <v-list-tile-action>
            <v-icon>lock_open</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Log in</v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="!authenticated"
          flat>
          <subscriptionForm subscriptionFormCompPosition='tooltipBar' subscriptionType='getDemoAccess' />
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <!-- top bar when on desktop -->
    <v-toolbar fixed >
      <v-toolbar-side-icon @click="drawer = !drawer" class="hidden-lg-and-up"></v-toolbar-side-icon>
      <v-toolbar-side-icon class="hidden-sm-and-down logo_img">
          <v-img :src="logoUrl"></v-img>
      </v-toolbar-side-icon>
      <v-toolbar-title>
        <router-link :to="this.$route.path" tag="span" style="cursor: pointer">
          <span class="secondary--text" style="font-size: 16px;" >{{this.$route.meta.label}}</span>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="hidden-lg-and-up feedback_toolbar">
        <feedback />
      </v-toolbar-title>

      <v-toolbar-items class="hidden-md-and-down">
        <v-btn
          flat
          router
          to="/">
          <v-icon left dark>home</v-icon> Home
        </v-btn>

        <v-btn  
          flat
          router
          to="/press">
          <v-icon left dark>search</v-icon> Press
        </v-btn>

        <v-btn  
          flat
          router
          to="/e-commerce-pulse">
          <v-icon left dark>hdr_strong</v-icon> E-Commerce Pulse
        </v-btn>

        <v-btn  
          flat
          router
          to="/lighthouse">
          <v-icon left dark>trending_up</v-icon> Lighthouse Index
        </v-btn>

        <v-menu offset-y>
          <v-btn style="-webkit-box-shadow: none!important; box-shadow: none!important;"
            slot="activator"
          >
            <v-icon left>add</v-icon> Work in Progress
          </v-btn>
          <v-list class="roll_menu">

            <v-list-tile>
                <v-btn flat style="height: 100%!important; width: 100%!important;margin: 0px!important;"
                  router
                  to="/about">
                  <v-icon left>info</v-icon>About
                </v-btn>
            </v-list-tile>
            <v-list-tile>
                <v-btn flat style="height: 100%!important; width: 100%!important;margin: 0px!important;"
                  disabled
                  router
                  to="/company-reports">
                  <v-icon left>work</v-icon>Company reports
                </v-btn>
            </v-list-tile>
            <v-list-tile>
                <v-btn flat style="height: 100%!important; width: 100%!important;margin: 0px!important;"
                  disabled
                  router
                  to="/se-airport-shops">
                  <v-icon left>local_airport</v-icon>Airports shops
                </v-btn>
            </v-list-tile>
            <v-list-tile>
                <v-btn flat style="height: 100%!important; width: 100%!important;margin: 0px!important;"
                  disabled
                  router
                  to="/se-airport-shops">
                  <!--v-img class="v-icon--left" style="width: 24px;" :src="trWikiImg" /> TR Wiki-->
                  <v-icon left>account_circle</v-icon> TR Wiki
                </v-btn>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-btn v-if="authenticated && this.showMenuItems('admin')"
          flat
          router
          to="/admin">
          <v-icon left dark>settings</v-icon> Admin
        </v-btn>

        <v-btn
          v-if="authenticated"
          flat
          @click="logout">
          <v-icon left dark>exit_to_app</v-icon>
          Logout
        </v-btn>

        <v-btn
          v-if="!authenticated"
          flat
          @click="login">
          <v-icon left dark>lock_open</v-icon>
          Log in
        </v-btn>
        <subscriptionForm v-if="!authenticated" subscriptionFormCompPosition='tooltipBar' subscriptionType='getDemoAccess' />
        <feedback />
      </v-toolbar-items>
    </v-toolbar>
    <v-progress-linear :indeterminate="progressLinear" v-bind="bind_progress_linear" ></v-progress-linear>

    <v-alert style=" width: 99%; text-align: center; margin-top: 70px;"
      v-if="isDemoVersion"
      :value="true"
      color="warning"
      outline
      >
      <span v-if="$route.name === 'press' ">
        <v-icon dark>warning</v-icon>
        This is a <strong>limited trial</strong> version of the Press module with a limited number of sources<v-tooltip right>
          <v-icon slot="activator" style="font-size: 12px; margin-bottom: 6px;" >help_outline</v-icon>
          <span>1 vs 7 in the full module</span>
        </v-tooltip>
        for a limited period of time<v-tooltip right>
          <v-icon slot="activator" style="font-size: 12px; margin-bottom: 6px;" >help_outline</v-icon>
          <span>6 months vs all history available in the full module</span>
        </v-tooltip>.
      </span>

      <span v-if="$route.name === 'airportShops' || $route.name === 'seAirportShops' ">
        <v-icon dark>warning</v-icon>
        This is a <strong>limited trial</strong> version of the Airport Shops module with a limited number of airports<v-tooltip right>
          <v-icon slot="activator" style="font-size: 12px; margin-bottom: 6px;" >help_outline</v-icon>
          <span>1 vs 100 in the full module</span>
        </v-tooltip>.
      </span>

      <span v-if="$route.name === 'companyReports' ">
        <v-icon dark>warning</v-icon>
        This is a <strong>limited trial</strong> version of the Company Reports module with a limited number of companies<v-tooltip right>
          <v-icon slot="activator" style="font-size: 12px; margin-bottom: 6px;" >help_outline</v-icon>
          <span>2 vs 15 (number is growing) in the full module</span>
        </v-tooltip> for a limited period of time<v-tooltip right>
          <v-icon slot="activator" style="font-size: 12px; margin-bottom: 6px;" >help_outline</v-icon>
          <span>1 year vs all history available in the full module</span>
        </v-tooltip>.
      </span>
      Please visit <router-link to="/subscription">our subscription page</router-link> to know more about the full modules.
    </v-alert>

    <v-alert style="width: 99%; text-align: center; margin-top: 70px;"
      v-if="isTrialVersion"
      :value="true"
      color="deep-orange"
      outline >
      <v-icon dark>warning</v-icon>
      This is a 7 days full trial version. After the 7 days you will enter the limited trial version of TR-Toolbox with limited content.
      Contact us if you wish to extend your full trial or have your full access.
      <br/>
      <strong>Remaining days: {{ trialVersionRemainingdaysViewed }}</strong>
    </v-alert>

    <main v-bind="bind_main">
      <v-layout row wrap>
        <v-flex md12>
          <div>
            <v-alert :value="errors_info.length > 0" type="error" dismissible @input="resetErrors()">
                <span v-for="(value, errorIndex) in errors_info" :key="errorIndex">
                    {{ value }}<br/>
                </span>
            </v-alert>
          </div>
        </v-flex>
      </v-layout>
      <router-view></router-view>
    </main>
    <login-signup-form />
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import feedback from './components/Feedback'
import USER from '@/graphql/User.gql'
import subscriptionForm from './components/Subscription/SubscriptionForm'
import LoginSignupForm from '@/components/LoginSignupForm'
import Vue from 'vue'

export default {
  name: 'App',
  data () {
    return {
      user: false,
      drawer: false,
      algolia_articles_index_name: process.env.VUE_APP_ALGOLIA_ARTICLES_INDEX_NAME,
      algolia_localizations_index_name: process.env.VUE_APP_ALGOLIA_LOCALIZATIONS_INDEX_NAME,
      algolia_company_reports_index_name: process.env.VUE_APP_ALGOLIA_COMPANY_REPORTS_INDEX_NAME,
      logoUrl: require('./assets/logo_tr_toolbox.png'), // eslint-disable-line no-undef
      trWikiImgDisabled: require('./assets/tr_wiki_dark_disabled.png'),
      trWikiImg: require('./assets/tr_wiki_dark.png')
    }
  },
  components: {
    feedback,
    subscriptionForm,
    LoginSignupForm
  },
  mounted () {
    // Check the user's auth status when the app
    // loads to account for page refreshing
    Vue.nextTick(async () => {
      await this.$auth0.onAuthenticated()
    })
  },
  async created () {
    if (!await this.$auth0.isAuthenticated()) {
      // clean localStorage if accessToken is expired
      this.$auth0.clearLocalStorage()
    }
    this.isAuthenticated()
    this.completeAuthentication()
  },
  watch: {
    // Everytime the route changes, check for auth status
    '$route': 'completeAuthentication'
  },
  methods: {
    ...mapMutations(['resetErrors', 'setAuthState']),
    login () {
      this.$auth0.login()
    },
    async logout () {
      this.$auth0.logout()
      this.setAuthState(false)
    },
    ...mapActions(['isAuthenticated', 'completeAuthentication']),
    showMenuItems (menu) {
      return (this.user && this.user.acl_app_access.indexOf(menu) > -1)
    },
    disableMenuItems (menu) {
      return !(this.user && this.user.acl_app_access.indexOf(menu) > -1)
    }
  },
  computed: {
    ...mapState(['errors_info', 'authenticated', 'progressLinear']),
    isDemoVersion () {
      // check demo access per module
      if (this.user === false || this.user === undefined) {
        return false
      }
      // Show demo version if trial is expired
      if (this.user.access_right.trial_version !== undefined && this.user.access_right.trial_version) {
        return false
      }

      if (this.$route.name === 'press' && this.user.access_right[this.algolia_articles_index_name].demo !== undefined && this.user.access_right[this.algolia_articles_index_name].demo) {
        return true
      }
      if ((this.$route.name === 'airportShops' || this.$route.name === 'seAirportShops') && this.user.access_right[this.algolia_localizations_index_name].demo !== undefined && this.user.access_right[this.algolia_localizations_index_name].demo) {
        return true
      }
      if (this.$route.name === 'companyReports' && this.user.access_right[this.algolia_company_reports_index_name].demo !== undefined && this.user.access_right[this.algolia_company_reports_index_name].demo) {
        return true
      }
      return false
    },
    isTrialVersion () {
      if (this.user === false || this.user === undefined) {
        return false
      }
      if (this.user.access_right.trial_version !== undefined && this.user.access_right.trial_version) {
        return true
      }
      return false
    },
    trialVersionRemainingdaysViewed () {
      if (this.user.trial_remaining_days > -1 && this.user.trial_remaining_days < 8) {
        return this.user.trial_remaining_days
      } else if (this.user.trial_remaining_days > 7) {
        return 7
      } else {
        return 0
      }
    },
    bind_progress_linear () {
      const binding = {}
      binding.style = 'position:fixed;background: white;'
      if (this.progressLinear && this.$vuetify.breakpoint.mdAndDown) {
        binding.style = 'position:fixed;top: 42px; z-index: 8;'
      }
      if (this.progressLinear && this.$vuetify.breakpoint.lgAndUp) {
        binding.style = 'position:fixed;top: 50px; z-index: 8;'
      }
      return binding
    },
    bind_main () {
      const binding = {}
      binding.style = 'padding-top:60px;'
      if (this.isDemoVersion || this.isTrialVersion) {
        binding.style = ''
      }
      return binding
    }
  },
  apollo: {
    user: {
      query: USER,
      skip () {
        return !this.$auth0.isAuthenticated()
      }
    }
  }
}
</script>
<style>
.feedback_toolbar button {
  height: 55.99px !important;
}
.container {
  padding:10px;
}

.roll_menu {
  padding: 0px!important;

}
.roll_menu .v-list__tile{
  padding: 0px!important;
  margin: 0px!important;
}
.roll_menu .v-btn__content{
  justify-content: left!important;
}

.bottom_panel {
  border-top: 1px solid #dadada;
}
.logo_img {
  width: 155px!important;
  margin-bottom: 17px!important;
}
.logo_img .v-btn__content {
  width: 160px!important;
}

.v-dialog .v-toolbar {
  height: 48px!important;
}
.v-dialog .v-toolbar__content {
  height: 48px!important;
}

</style>
